<template>
  <div
    v-if="healthdata"
    class="container"
  >
    <div class="row">
      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-body text-center">
            <router-link
              class="btn btn-primary"
              :to="{name: 'scorecard'}"
            >
              &lt;&lt; Back to Scorecard
            </router-link>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4>Your Lifestyle Score</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              <linear-gauge
                :show-title="false"
                :show-display-val="false"
                :show-hero-metric="true"
                :title="healthdata.scorecard.factor_groups.lifestyle.points"
                :value="healthdata.scorecard.factor_groups.lifestyle.percentage"
              />
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4><i class="fa fa-bed" /> Sleep</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              You sleep 6 to 8 hours {{ healthdata.answers.lifestyle.sleep.days_6_8_hours }} day(s) per week.
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4><i class="fa fa-smoking-ban" /> Smoking</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              <span
                v-if="healthdata.answers.lifestyle.smoking.last_smoked == 'never'"
                class="text-green"
              >You have never smoked.</span>
              <span
                v-if="healthdata.answers.lifestyle.smoking.last_smoked == 'over-2-years'"
                class="text-green"
              >You last smoked over 2 years ago.</span>
              <span
                v-if="healthdata.answers.lifestyle.smoking.last_smoked == '1-2-years'"
                class="text-green"
              >You last smoked 1-2 years ago.</span>
              <span
                v-if="healthdata.answers.lifestyle.smoking.last_smoked == '6-12-months'"
                class="text-yellow-dark"
              >You last smoked 6-12 months ago.</span>
              <span
                v-if="healthdata.answers.lifestyle.smoking.last_smoked == '0-5-months'"
                class="text-red"
              >You have smoked within the past 6 months.</span>
              <span
                v-if="healthdata.answers.lifestyle.smoking.last_smoked == 'current'"
                class="text-red-dark"
              >You currently smoke.</span>
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4><i class="fa fa-glass-cheers" /> Alcohol</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              You currently drink {{ healthdata.answers.lifestyle.alcohol.drinks_perweek }} alcoholic drink(s) per week.
            </p>
            <p
              v-if="healthdata.answers.lifestyle.alcohol.five_single_stting_last_6_months"
              class="alert alert-danger"
            >
              CAUTION! You are at the threshold of what the CDC considers an alcoholic. Please contact your physician or a FFF RD for guidance on this matter.
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-body text-center">
            <router-link
              class="btn btn-primary"
              :to="{name: 'scorecard'}"
            >
              &lt;&lt; Back to Scorecard
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    healthdata() {
      return this.$store.getters['healthData/current']
    },
  },
  mounted () {
    this.$store.dispatch('healthData/GET_INITIAL_DATA');
  }
}
</script>
